import { css } from 'linaria';

export const newKitchenHeaderModalTitle = css`
  @media (--only-mobile) {
    text-align: center;
  }
`;

export const newKitchenHeaderSection = css`
  @media (--only-desktop) {
    && {
      margin-bottom: 80px;
    }
  }
`;

export const newKitchenHeaderSectionKz = css`
  && {
    margin-bottom: 0;
  }
`;

export const newKitchenHeaderTitle = css`
  && {
    width: 517px;
    margin-bottom: 16px;
    font-family: LMNA, Roboto, apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell,
      'Open Sans', 'Helvetica Neue', sans-serif;

    @media (--only-mobile) {
      width: 100%;
    }
  }
`;

export const newKitchenHeaderText = css`
  && {
    width: 460px;
    margin-bottom: 40px;
    line-height: 28px;

    @media (--only-mobile) {
      width: 100%;
      margin-bottom: 16px;
      line-height: 24px;
    }
  }
`;

export const newKitchenHeaderGrid = css`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 0;
  margin: 0;
  column-gap: 24px;
  list-style: none;

  @media (--to-desktop) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    row-gap: 24px;
  }

  @media (--only-mobile) {
    column-gap: 12px;
    row-gap: 12px;
  }
`;

export const newKitchenHeaderItem = css`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 24px 20px;
  font-family: inherit;
  text-align: left;
  background-color: var(--background-secondary);
  border: none;
  border-radius: var(--rounding-m);
  cursor: pointer;
  row-gap: 32px;

  &:hover {
    background-color: var(--control-minor);
  }

  @media (--only-mobile) {
    padding: 16px 12px;
  }
`;

export const newKitchenHeaderItemImage = css`
  width: 36px;
  height: 36px;

  @media (--only-mobile) {
    position: absolute;
    top: 16px;
    left: 12px;
    width: 32px;
    height: 32px;
  }
`;

export const newKitchenHeaderItemContent = css`
  display: flex;
  justify-content: space-between;

  @media (--only-mobile) {
    flex-direction: column-reverse;
    row-gap: 8px;
    align-items: flex-end;
  }
`;

export const newKitchenHeaderItemText = css`
  width: 203px;

  @media (--from-tablet) {
    white-space: break-spaces;
  }

  @media (--only-desktop) {
    width: 143px;
  }

  @media (--only-tablet) {
    width: 244px;
  }

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const newKitchenHeaderItemIconWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: max-content;
  padding: 5px;

  @media (--only-mobile) {
    padding: 8px 4px;
  }
`;

export const newKitchenHeaderItemIcon = css`
  && {
    @media (--only-mobile) {
      width: 16px;
      height: 16px;
    }
  }
`;

export const newKitchenHeaderModal = css`
  && {
    @media (--only-tablet) {
      max-width: 480px;
    }
  }
`;

export const newKitchenHeaderModalContent = css`
  && {
    padding-bottom: 40px;
  }
`;

export const newKitchenHeaderModalText = css`
  margin-bottom: 8px;
`;

export const newKitchenHeaderModalList = css`
  && {
    margin-bottom: 8px;

    li:not(:last-of-type) {
      margin-bottom: 4px;
    }
  }
`;
